module.exports = "<corporate-transportation-submissions-page></corporate-transportation-submissions-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/corporateTransportationSubmissions.html
// module id = 2108
// module chunks = 0